export enum toastTypes {
	success = "success",
	error = "error"
}